var render = function render() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h

  return _c(
    "div",
    {
      staticClass: "cw-block cw-block-text",
    },
    [
      _c("courseware-default-block", {
        ref: "defaultBlock",
        attrs: {
          block: _vm.block,
          canEdit: _vm.canEdit,
          isTeacher: _vm.isTeacher,
          preview: false,
        },
        on: {
          showEdit: _vm.initCurrent,
          storeEdit: _vm.storeText,
          closeEdit: _vm.initCurrent,
        },
        scopedSlots: _vm._u(
          [
            {
              key: "content",
              fn: function fn() {
                return [
                  _c("section", {
                    ref: "content",
                    staticClass: "formatted-content ck-content",
                    domProps: {
                      innerHTML: _vm._s(_vm.currentText),
                    },
                  }),
                ]
              },
              proxy: true,
            },
            _vm.canEdit
              ? {
                  key: "edit",
                  fn: function fn() {
                    return [
                      _c(
                        "div",
                        {
                          ref: "ckeditor",
                        },
                        [
                          _c("ckeditor", {
                            attrs: {
                              editor: _vm.editor,
                              config: _vm.editorConfig,
                            },
                            on: {
                              ready: _vm.onReady,
                            },
                            model: {
                              value: _vm.currentText,
                              callback: function callback($$v) {
                                _vm.currentText = $$v
                              },
                              expression: "currentText",
                            },
                          }),
                        ],
                        1
                      ),
                    ]
                  },
                  proxy: true,
                }
              : null,
            {
              key: "info",
              fn: function fn() {
                return [
                  _vm._v(_vm._s(_vm.$gettext("Informationen zum Text-Block"))),
                ]
              },
              proxy: true,
            },
          ],
          null,
          true
        ),
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }